import Memoizr from './http-memoizr'
import config from '../../config'

const memoizrOptions = {
  duration: config.cacheDuration.defaultData,
  timeout: config.api.timeout
}

if (config.api.useGzip) {
  memoizrOptions.headers = {
    'Accept-Encoding': 'gzip'
  }
}

export default new Memoizr(Object.assign({}, config.cache, memoizrOptions))



// WEBPACK FOOTER //
// ./lib/memoizr.js